import "./MyPathPreview.scss";

import { Container } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { skipToken } from "@reduxjs/toolkit/query/react";
import { useParams, Redirect, useHistory } from "react-router-dom";

import { PageTitle } from "@thrivetribe/gloji.ui.molecules.page-title";
import { SILVER_EXTRA_LIGHT } from "@thrivetribe/gloji.enums.brand-colors";
import { greyVelvet } from "../../../assets/img/bg";
import { CircularLoader } from "../../atoms/Loaders";
import { SectionHeader, SectionHeading, SectionIntro } from "../../atoms/SectionHeader";
import useUserId from "../../hooks/useUserId";
import HeroBanner from "../../organisms/HeroBanner";
import PageBackground from "../../organisms/PageBackground";
import ProgrammeOverviewPreview from "../../organisms/ProgrammeOverviewPreview";
import { useGetProfileByIdQuery } from "../../../redux/profileApiV3";
import { useGetProgrammeOverviewQuery } from "../../../redux/programmeApi";

import { Programmes } from "../../../data/Programme";
import { Button } from "@thrivetribe/gloji.ui.atoms.button";

const MyPathExplore = () => {
  const [userId] = useUserId();
  let { programmeSlug } = useParams();
  const history = useHistory();

  const { data: profile } = useGetProfileByIdQuery(userId ?? skipToken);

  const {
    data: overview,
    isSuccess: overviewSuccess,
    isUninitialized: overviewUnit,
  } = useGetProgrammeOverviewQuery(programmeSlug ?? skipToken);

  const currentProgramme = Programmes.find(x => x.slug === programmeSlug);

  if (profile.currentJourneys.map(x => x.programmeId).includes(currentProgramme.programmeId)) {
    return <Redirect to={`/my-path/${programmeSlug}`} />;
  }

  return (
    <PageBackground bgImage={greyVelvet}>
      <Helmet>
        <title>My path {currentProgramme.name} | Gloji</title>
      </Helmet>
      {overviewSuccess && !overviewUnit ? (
        <div className="my-path-page">
          <HeroBanner>
            <PageTitle color={SILVER_EXTRA_LIGHT}>{currentProgramme.name}</PageTitle>
            <div className="hero-banner__inner-container">
              <p>
                Boost your health and lose weight with 12 weeks of interactive videos, online articles,
                recipes and more.
              </p>
            </div>
            <Button
              className="hero-banner__button"
              tabIndex="-1"
              color="primary"
              onClick={() => {
                history.push(`/sign-up/eligibility-checker/${programmeSlug}`);
              }}
            >
              Check Eligibility
            </Button>
          </HeroBanner>

          <Container className="main-content__container">
            <section className="">
              <SectionHeader className="programme-header">
                <SectionHeading size="h2">Our {currentProgramme.name.toLowerCase()} path</SectionHeading>
                <SectionIntro className="programme-intro">
                  Take a look at what you’ll discover as you take steps to lose weight with gloji.
                </SectionIntro>
              </SectionHeader>
              <ProgrammeOverviewPreview programmeOverview={overview} programmeSlug={programmeSlug} />
            </section>
          </Container>
        </div>
      ) : (
        <CircularLoader color="primary" size={40} />
      )}
    </PageBackground>
  );
};

export default MyPathExplore;
